import type { DepositBonuses, DepositBonusesNoLimits, DepositBonusesRaw, DepositBonusesWithLimits, FreeRoundsBonus, FreeRoundsBonuses, FreeRoundsBonusesRaw, FreeRoundsBonusRaw, NextDepositBonus, NoDepositBonus, WelcomeDepositBonus } from '@/types';

export function isNextDepositBonus(bonus: DepositBonuses | DepositBonusesRaw | FreeRoundsBonuses): bonus is NextDepositBonus {
    return bonus.type === 'next_deposit';
}
export function isNoDepositBonus(bonus: DepositBonuses | DepositBonusesRaw | FreeRoundsBonuses): bonus is NoDepositBonus {
    return bonus.type === 'no_deposit' && 'no_deposit_bonus_amount' in bonus;
}
export function isWelcomeDepositBonus(bonus: DepositBonuses | DepositBonusesRaw | FreeRoundsBonuses): bonus is WelcomeDepositBonus {
    return bonus.type === 'welcome' && 'bonus_percent' in bonus;
}
export function isFreeRoundsBonus(bonus: DepositBonuses | DepositBonusesRaw | FreeRoundsBonuses): bonus is FreeRoundsBonus {
    return 'fs_count_remaining' in bonus;
}
export function isDepositBonus(bonus: DepositBonuses | DepositBonusesRaw | FreeRoundsBonuses): bonus is DepositBonuses {
    return 'bonus_percent' in bonus;
}
export function isDepositBonusWithLimits(bonus: DepositBonuses | DepositBonusesRaw): bonus is DepositBonusesWithLimits {
    return isNextDepositBonus(bonus) || isWelcomeDepositBonus(bonus);
}
// && 'min_dep' in bonus && 'max_dep' in bonus
export function isDepositBonusNoLimits(bonus: DepositBonuses | DepositBonusesRaw): bonus is DepositBonusesNoLimits {
    return isNoDepositBonus(bonus);
}
export function isFreeRoundsBonusRaw(bonus: DepositBonuses | DepositBonusesRaw | FreeRoundsBonusRaw | null): bonus is FreeRoundsBonusRaw {
    return bonus !== null && 'count' in bonus && 'game' in bonus;
}

export function isDepositBonusRaw(bonus: DepositBonuses | DepositBonusesRaw | FreeRoundsBonusRaw | null): bonus is DepositBonusesRaw {
    return bonus !== null && 'bonus_percent' in bonus && 'currency_limits' in bonus;
}
export function isNoRawFreeRoundsBonus(bonus: DepositBonuses | DepositBonusesRaw | FreeRoundsBonuses | FreeRoundsBonusesRaw): bonus is FreeRoundsBonuses {
    return 'loadingItem' in bonus && 'fs_count_remaining' in bonus;
}
export function isNoRawDepositBonus(bonus: DepositBonuses | DepositBonusesRaw | FreeRoundsBonuses | FreeRoundsBonusesRaw): bonus is DepositBonuses {
    return 'loadingItem' in bonus && 'bonus_percent' in bonus;
}
